import React from 'react';
import { useAppSelector } from 'store/hooks';
import style from './mobileTabBar.module.scss';
import { selectCategories, selectPageIsLoading } from 'store/page/pageSlice';
import Skeleton from '@mui/material/Skeleton';
import { useMatch, useSearchParams } from 'react-router-dom';
import SectionLink from 'components/sectionLink/sectionLink';
import map from 'lodash-es/map';

export default function MobileTabBar() {
  const mainChecker = useMatch('/:name/*')?.params.name;
  const [searchParams] = useSearchParams();
  const isSearchContext = mainChecker === 'search' || mainChecker === 'mapping';
  const categories = useAppSelector(selectCategories);
  const pageIsLoading = useAppSelector(selectPageIsLoading);

  return (
    <div className={style.container}>
      {pageIsLoading ? (
        <>
          <Skeleton variant="text" width={150} height={22} />
          <Skeleton variant="text" width={150} height={22} />
          <Skeleton variant="text" width={150} height={22} />
        </>
      ) : (
        map(categories, (category) => {
          if (isSearchContext) {
            searchParams.set('category', category.id);
          }

          searchParams.delete('page');

          return (
            <SectionLink
              className={'adaptive-mobileTabBar__sectionLink adaptive-f18'}
              key={category.id}
              categoryId={category.id}
              to={
                isSearchContext
                  ? `/search?${searchParams.toString()}`
                  : `${category.href}?${searchParams.toString()}`
              }
            >
              {category.id}
            </SectionLink>
          );
        })
      )}
    </div>
  );
}
